module.exports = {
  colors: {
    main: '#043186',
    sub: '#B1C1EE',
    text: '#5C5B52', // black
    like: '#FFACB7', // pink
    green: '#00ffa9',
    golden: '#FADB6A',
    white: '#ffffff',
    black: '#000000',
    blue: '#0099ff',
    grey: '#888888',
    orange: '#E7AC3E', // orange
    red: '#F04A4A', // red,
  },
  gap: 12, //px
  ratio: 1.775, //thumbnail ratio
  breakpoint: 767,
  maxWidth: 1120,
  shadowProps: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.2,
    shadowRadius: 3,
    shadowColor: '#666',
    backgroundColor: 'white',
    elevation: 10,
  },
};
